module.exports = __webpack_public_path__ + "img/list.ae72e2e9.png";